import { apiCall } from './_helper';

// Used for displaying planned maintenance message
// Tested and working: 4/6/2025
export const getMaintenanceDetails = async () => {
  return await apiCall({
    url: 'maintenance/maintenance',
    notJSON: true,
  });
};
